import { createFileRoute } from '@tanstack/react-router'
import EmailTemplateList from 'Admin/components/emailTemplate/EmailTemplateList'

import { Guard } from '../-guard'

export const Route = createFileRoute('/admin/emailtemplates')({
    component: () => (
        <Guard claims={['opus_royalty']}>
            <EmailTemplateList />
        </Guard>
    ),
})
